import { CheckoutState } from '../../state';
import { areSyncExpressCheckoutEligibleCommonRulesMet } from '../expressCheckoutConditions';
import { TLDSupportsGooglePay } from './TLDSupportsGooglePay';

export const areSyncExpressGooglePayEligibleRulesMet = (state: CheckoutState) =>
    areSyncExpressCheckoutEligibleCommonRulesMet(state) &&
    TLDSupportsGooglePay(state);
